import { render, staticRenderFns } from "./FormRL02_2.vue?vue&type=template&id=f2f5f956"
import script from "./FormRL02_2.vue?vue&type=script&lang=js"
export * from "./FormRL02_2.vue?vue&type=script&lang=js"
import style0 from "./FormRL02_2.vue?vue&type=style&index=0&id=f2f5f956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports